/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import './answer-option.scss';
import './modifier/modifier.scss';
